/* eslint-disable max-lines */

export const config = {
    name: 'assetHandover-clue',
    selection: true,
    index: false,
    searchFields: [
        {
            name: '跟进状态',
            value: 'followStatusList',
            type: 'select',
            isFixed: true,
            multiple: true,
            optionNum: 'LCRM_FOLLOW_UP_STATUS',
            span: 5
        }
    ],
    columns: [
        {
            label: '客户联系人',
            prop: 'customerContact',
            width: 200
        },
        {
            label: '公司名称',
            prop: 'companyName',
            width: 200
        },
        {
            label: '跟进状态',
            prop: 'followStatus',
            optionsKey: 'LCRM_FOLLOW_UP_STATUS',
            type: 'slot',
            slot: true,
            editSlot: true,
            width: 200
        },
        // {
        //     label: '手机',
        //     width: 200,
        //     prop: 'mobile'
        // },
        // {
        //     label: '电话',
        //     width: 200,
        //     prop: 'phone'
        // },
        {
            label: '承接人',
            prop: 'receiverName',
            type: 'slot',
            slot: true,
            editSlot: true,
            width: 100,
            fixed: 'right'
        }
    ]
};
